import { render, staticRenderFns } from "./SingleStepTeamOrCompetition.vue?vue&type=template&id=5199a09b"
import script from "./SingleStepTeamOrCompetition.vue?vue&type=script&setup=true&lang=ts"
export * from "./SingleStepTeamOrCompetition.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports